<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">

							</h6>
							<div class="element-box-tp">
								<div class="element-box" v-for="i in e">
									<h5 class="form-header">[GET] {{ i.e }}</h5>
									<div class="form-desc">{{ i.d }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'hello',
        data () {
            return {
                t: this.$root.t,
				e: [
					{e: 'api/v2/feedstation/uof/sports?language=en'},
					{e: 'api/v2/feedstation/uof/tournaments?id=102&sport_id=1&urn_type=sport_id&language=en', d: 'urn_type: Available values : sport_id, tournament_id'},
					{e: 'api/v2/feedstation/uof/live_matches?language=en'},
					{e: 'api/v2/feedstation/uof/pre_matches?language=en&start=0 (Index not time)'},
					{e: 'api/v2/feedstation/uof/player?language=en&id=0'},
					{e: 'api/v2/feedstation/uof/markets?language=en'},
					{e: 'api/v2/feedstation/uof/variants?language=en'},
					{e: 'api/v2/feedstation/uof/match_status?language=en'},
				]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/financial.vue